import React from "react";
import { Button } from "../ui/button";
import { ChevronUp, ChevronDown, Eye, EyeOff, Pencil, Trash2, Rocket } from "lucide-react";

export const RowControls = ({ hidden, isFirst, isLast, onUp, onDown, onToggleHide, onEdit, onDelete, testid, extra, isDraft, onPublish }) => (
  <div className="flex items-center gap-0.5 shrink-0">
    {extra}
    {isDraft && onPublish && (
      <Button size="sm" onClick={onPublish} data-testid={`${testid}-publish`} title="Publish to live site"
        className="h-8 px-2.5 bg-[#3FB950]/15 text-[#3FB950] hover:bg-[#3FB950] hover:text-[#0B0C10] rounded-sm text-xs font-semibold">
        <Rocket size={13} className="mr-1" /> Go live
      </Button>
    )}
    <Button size="icon" variant="ghost" disabled={isFirst} onClick={onUp} data-testid={`${testid}-up`} title="Move up"
      className="h-8 w-8 text-[#A1A1AA] hover:text-white disabled:opacity-25"><ChevronUp size={16} /></Button>
    <Button size="icon" variant="ghost" disabled={isLast} onClick={onDown} data-testid={`${testid}-down`} title="Move down"
      className="h-8 w-8 text-[#A1A1AA] hover:text-white disabled:opacity-25"><ChevronDown size={16} /></Button>
    <Button size="icon" variant="ghost" onClick={onToggleHide} data-testid={`${testid}-hide`}
      title={hidden ? "Hidden — click to show" : "Visible — click to hide"}
      className={`h-8 w-8 ${hidden ? "text-[#E0A44F]" : "text-[#A1A1AA]"} hover:text-white`}>
      {hidden ? <EyeOff size={16} /> : <Eye size={16} />}
    </Button>
    {onEdit && <Button size="icon" variant="ghost" onClick={onEdit} data-testid={`${testid}-edit`} title="Edit"
      className="h-8 w-8 text-[#C8A97E] hover:text-white"><Pencil size={15} /></Button>}
    <Button size="icon" variant="ghost" onClick={onDelete} data-testid={`${testid}-delete`} title="Delete"
      className="h-8 w-8 text-[#E04F5F] hover:bg-[#E04F5F]/10"><Trash2 size={15} /></Button>
  </div>
);

export const DraftBadge = ({ show }) => show
  ? <span className="text-[10px] uppercase font-bold tracking-wider text-[#3FB950] bg-[#3FB950]/10 px-1.5 py-0.5 rounded-sm">Draft</span>
  : null;
